import React, { useState } from 'react';
import { Leaf } from 'lucide-react';

const Menu = ({ menu }) => {
  const [selectedCategory, setSelectedCategory] = useState(menu.categories[0]);

  return (
    <div className="menu-section">
      <div className="menu-header">
        <h3 className="menu-title">Our Menu</h3>
        <p className="menu-subtitle">Explore our culinary delights</p>
      </div>

      <div className="menu-categories">
        {menu.categories.map((category) => (
          <button
            key={category.id}
            onClick={() => setSelectedCategory(category)}
            className={`menu-category-button ${
              selectedCategory.id === category.id ? 'active' : ''
            }`}
          >
            {category.name}
          </button>
        ))}
      </div>

      <div className="menu-items-grid">
        {selectedCategory.items.map((item) => (
          <div key={item.id} className="menu-item-card">
            <div className="menu-item-header">
              <div className="menu-item-name-section">
                <h4 className="menu-item-name">{item.name}</h4>
                {item.vegetarian && (
                  <span className="menu-veg-badge">
                    <Leaf size={14} />
                  </span>
                )}
              </div>
              <span className="menu-item-price">₹{item.price}</span>
            </div>
            <p className="menu-item-description">{item.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Menu;
